<template>
  <div class="content wrapper" id="msgBox" ref="msgBox">
    <div class="numC" @click="gopage" v-if="tid && numC && numC != 0">{{numC}}</div>
    <div class="chat">
      <!-- <div class="syetem-notice" @click="playVoice">
        文明用语，严谨私下联系，私下交易平台概不负责。
      </div> -->
      <!-- <chat /> -->
      <!-- <div class="ps-time">昨天19:31</div> -->
      <div class="more" v-if="moreShow"  @click="more">点击查看更多</div>
      <div class="ps-time"></div>
      <!-- <chat :isme="true" /> -->
      <template v-for="(item, index) in chatMsgList">
        <!-- <template v-if="item.type != 3"> -->
          <chat v-if="!item.page" :data="item" :key="index" @userPay="userPay" :reloadTimer="reloadTimer" />
          <div v-if="item.page" :id="'page'+item.page" :key="index"></div>
          <template v-if="item.msgStatus == 999 && !isTeacher">
            <div style="display:flex;justify-content: center;width:100%">
              <div class="txt_center notic-btn main_bg cf" @click="noticeService(item)">
                {{item.timerOut <= 0 ? '通知' : item.timerOut +'秒后可通知'}}
              </div>
            </div>
          </template>
      </template>
    </div>

    <div :style="`height: ${50 + footHeight}px`"></div>
    <div class="footer" v-if="userMsgInpBox">
      <!-- <div
        class="quick"
        v-show="isTeacher && inputFocus"
        @click.stop="handleClick"
      >
        <div
          v-for="(item, index) in quickList"
          :key="index"
          @click.stop="sendQuick(item.text)"
        >
          {{ item.text }}
        </div>
        <div class="add-quick" @click="$router.push('phrase')">
          自定义快捷短语
        </div>
      </div> -->
      <div class="send-msg">
        <div @click="handleVoi">
          <img src="../../assets/msg/key.png" alt="" v-if="isVoice" />
          <img src="../../assets/msg/voice.png" alt="" v-else />
        </div>
        <div class="send-input">
          <div
            v-if="isVoice"
            contenteditable="false"
            class="voice-box"
            ref="voicebox"
            @touchstart="ontouchstart"
            @touchcancel="ontouchend"
            @touchend="ontouchend"
          >
            按住 说话
          </div>
          <div
            v-else
            id="send-input"
            ref="send-input"
            contenteditable="true"
            class="send-input-box"
            @focus.stop="onfocus"
            @blur.stop="onblur"
            @input.stop="oninput"
            @click.stop="oninputclick"
          ></div>
          <!-- <input
            type="text"
            id="send-input"
            ref="send-input"
            v-model="inputValue"
            @focus.stop="onfocus"
            @blur.stop="onblur"
            style="border:0"
          /> -->
        </div>
        <img
          class="expression"
          src="../../assets/msg/expression.png"
          @click="handleBiaoq"
          alt=""
        />
        <div class="send-btn" v-if="inputValue.length" @click="sendmsg">
          发送
        </div>
        <img
          src="../../assets/msg/more.png"
          @click="showMenu = !showMenu"
          v-else
        />
      </div>
      <div class="foot-menu" v-show="showMenu">
        <div class="foot-menu-scroller">
          <uploader :after-read="sendImg" capture="camera">
            <div class="foot-menu-item">
              <img src="../../assets/msg/photo.png" alt="" />
              <p>拍摄</p>
            </div>
          </uploader>
          <uploader :after-read="sendImg">
            <div class="foot-menu-item">
              <img src="../../assets/msg/img.png" alt="" />
              <p>图片</p>
            </div>
          </uploader>
          
          <div @click="showkj = true">
            <img src="../../assets/msg/js.png" alt="" />
            <p>快捷短语</p>
          </div>
          <div @click="endSever(1)" v-if="isTeacher">
            <img src="../../assets/msg/6.png" alt="" />
            <p>退款</p>
          </div>
          <!-- <template v-if="userid == 11056 || userid == 17802"> -->
            <div class="more-list" @click="dsPopShow = true" v-if="!isTeacher">
              <img src="../../assets/msg/7.png"/>
              <p>打赏</p>
            </div>
            <div class="more-list" @click="yqPopShow = true" v-if="isTeacher">
              <img src="../../assets/msg/8.png"/>
              <p class="more-list-title">邀请付款</p>
            </div>
          <!-- </template> -->
          <div @click="endSever(0)">
            <img src="../../assets/msg/end.png" alt="" />
            <p>结束服务</p>
          </div>
        </div>
      </div>
      <!-- 表情 -->
      <div class="foot-menu-bq" v-show="showbq">
        <div class="bq">
          <span v-for="q in bq" :key="q" @click="sendBiaoQing(q)">
            <!-- <img :src="showBiaoQing(q)" alt="" /> -->
            {{q}}
          </span>
        </div>
      </div>
      <!-- 快捷 -->
      <div class="foot-menu-bq foot-menu-kjdu" v-show="showkj">
        <div class="quick" @click.stop="handleClick">
          <div
            v-for="(item, index) in quickList"
            :key="index"
            @click.stop="sendQuick(item.text)"
          >
            {{ item.text }}
          </div>
          <div class="add-quick" @click="$router.push({path:'phrase',query:{tid:tid}})">
            自定义快捷短语
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="serveShow"
      show-cancel-button
      title="请选择要完成的订单"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    >
      <div class="dialog-list">
        <div
          class="dialog-list-item"
          v-for="(item, index) in orderServe"
          :key="index"
          @click="selectServeItem(item)"
          :class="chooseServe.id == item.id ? 'choose' : ''"
        >
          {{ item.goods_name }}
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="dialogShow" :showConfirmButton="false">
      <div class="c-dialog-list">
        <img src="@/assets/1.png" alt="" class="image" srcset="" />
        <div class="name-box">
          {{ dioTitle }}
        </div>
        <div class="dio-btn-flex">
          <div class="dio-cancel" @click="handleCancel">取消</div>
          <div class="dio-sure" @click="handleConfirm">确定</div>
        </div>
      </div>
    </van-dialog>

    <!-- 打赏弹窗 -->
    <van-dialog v-model="dsPopShow" :showConfirmButton="false">
      <div class="pop-pop">
				<div class="flex flex_end pr20 pt20">
          <van-icon name="cross" color="#666" size="18" @click="dsPopShow = false" />
				</div>
				<div class="txt_center pt20 f36">打赏</div>
				<div class="plr30">
					<div class="">
						<div class="p-l flex flex_between flex_items plr30">
							<input type="digit" class="pop-int" placeholder="请输入金额" v-model="money">
							<span>元</span>
						</div>
						<div class="payment-op flex flex_between flex_items" style="height: .80rem;">
						  <div style="font-size:.25rem">
						    支付方式
						  </div>
							<RadioGroup v-model="radio" direction="horizontal" style="font-size:.25rem">
                <!-- <Radio name="1" checked-color="#4fd9d5">微信</Radio> -->
                <Radio name="2" checked-color="#4fd9d5">支付宝</Radio>
                <Radio name="3" checked-color="#4fd9d5" style="margin-right:0"
                  >金币</Radio
                >
              </RadioGroup>
						</div>
					</div>
					<div class="pop-btn" @click="dsFn">确认打赏</div>
				</div>
			</div>
    </van-dialog>
    <!-- 老师邀请付款弹窗 -->
    <van-dialog v-model="yqPopShow" :showConfirmButton="false">
      <div class="pop-pop">
				<div class="flex flex_end pr20 pt20">
					<van-icon name="cross" color="#666" size="18" @click="yqPopShow = false" />
				</div>
				<div class="txt_center pt20 f36">邀请付款</div>
				<div class="plr30">
					<div class="">
						<div class="p-l flex flex_between flex_items plr30">
							<input type="digit" class="pop-int" placeholder="请输入金额" v-model="money">
							<span>元</span>
						</div>
            <div class="p-l flex flex_between flex_items plr30">
							<input type="text" class="pop-int" placeholder="请输入付款备注" v-model="title">
						</div>
					</div>
					<div class="pop-btn" @click="yqFn">邀请付款</div>
				</div>
			</div>
    </van-dialog>
    <!-- 用户邀请付款弹窗 -->
    <van-dialog v-model="userPayPop" :showConfirmButton="false">
      <div class="pop-pop">
				<div class="flex flex_end pr20 pt20">
					<van-icon name="cross" color="#666" size="18" @click="userPayPop = false" />
				</div>
				<div class="txt_center pt20 f36">邀请付款</div>
				<div class="plr30">
					<div class="">
						<div class="p-l flex flex_between flex_items plr30">
							<div>{{userPayItem.money}}</div>
							<span>元</span>
						</div>
							<div class="payment-op flex flex_between flex_items" style="height: .80rem;">
						  <div style="font-size:.25rem">
						    支付方式
						  </div>
							<RadioGroup v-model="radio" direction="horizontal" style="font-size:.25rem">
                <!-- <Radio name="1" checked-color="#4fd9d5">微信</Radio> -->
                <Radio name="2" checked-color="#4fd9d5">支付宝</Radio>
                <Radio name="3" checked-color="#4fd9d5" style="margin-right:0"
                  >金币</Radio
                >
              </RadioGroup>
						</div>
					</div>
					<div class="pop-btn" @click="qrFn">确认付款</div>
				</div>
			</div>
    </van-dialog>

    <div class="popmask" v-if="loadingPop">
      <img src="@/assets/loader1.svg" class="l-img" style="width:40px">
    </div>
  </div>
</template>

<script>
import {  RadioGroup, Radio } from "vant";
import chat from "./components/sendChat.vue";
import bq from "../../utils/bq";
import twemoji from "twemoji";
import wx from "jweixin-module";
import MobileDetect from "mobile-detect";
import { Uploader, Dialog } from "vant";

import { uploadimg ,SOHERF} from "../../utils/tool";
import BenzAMRRecorder from "benz-amr-recorder";
import $ from "jquery";
import {$formatDates,getQueryString} from '@/utils/tool'
export default {
  name: "",
  props: {},
  components: { chat, Uploader, [Dialog.Component.name]: Dialog.Component , Radio, RadioGroup},
  data() {
    return {
      userPayItem:{},
      showkj: false,
      dialogShow: false,
      token: localStorage.getItem("token"),
      isTeacher:
        JSON.parse(localStorage.getItem("user")).is_teacher == 1 ? true : false,
      bq: bq,
      userid:JSON.parse(localStorage.getItem("user")).id,
      inputFocus: false,
      isVoice: false,
      inputValue: "",
      footHeight: 0,
      showMenu: false,
      serveShow: false,
      showbq: false,
      sel: "",
      range: "",
      chatMsgList: [],
      quickList: [],
      inputFocusShow: false,
      orderServe: [],
      chooseServe: {},
      userMsgInpBox: true, //是否可以聊天
      dioTitle: "是否确定结束当前订单？",
      serverCont: "",
      socketFlag:this.$store.getters.socketFlag,
      userSendMsgContent:{},//发送出去的消息
      sendAllMsgArr:[],//发送出去的消息数组
      moreShow:false,
      total:0,
      page:1,
      tid:'',//老师端 快捷消息用老师的id
      userAvatar:'',//发送消息显示的头像
      numC:0,
      nightTimeB:0,//夜间订单开始时间
      nightTimeE:0,//夜间订单结束时间
      serTimerArr:[],
      loadingPop:false,
      dsPopShow:false,//打赏弹窗
      userPayPop:false,//用户付款弹窗
      yqPopShow:false,//老师邀请付款
      money:'',
      radio:'2',
      title:'',
      allGold: JSON.parse(localStorage.getItem("user")).gold,
      reloadTimer:0,
      href: "http://h5.keyice.club/alipay/",
    };
  },
  computed: {
    showBiaoQing() {
      return function(data) {
        return this.extractImgUrl(data);
      };
    },
  },
  destroyed(){
    if(this.serTimerArr.length != 0){
      this.serTimerArr.map(r => {
        clearInterval(r)
      })
    }
  },
  watch: {
    '$store.state.app.socketFlag':{
      handler: function(newVal) {
        console.log(newVal,'-----socketFlag-------');
        this.socketFlag = newVal;
        if (newVal == 1) {
          this.sendSoMsg()
        }
      },
      deep: true
    },
    showMenu(val) {
      if (val) {
        this.showbq = false;
        this.showkj = false;
        this.footHeight = 120;
        this.scrollToBottom();
      }
      if (!this.showMenu && !this.showbq && !this.showkj) {
        this.footHeight = 0;
      }
    },
    showbq(val) {
      if (val) {
        this.showMenu = false;
        this.showkj = false;
        this.footHeight = 120;
        this.scrollToBottom();
      }
      if (!this.showMenu && !this.showbq && !this.showkj) {
        this.footHeight = 0;
      }
    },
    showkj(val) {
      if (val) {
        this.showMenu = false;
        this.showbq = false;
        this.footHeight = 120;
        this.scrollToBottom();
      }
      if (!this.showMenu && !this.showkj && !this.showbq) {
        this.footHeight = 0;
      }
    },
    isVoice(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.voicebox.innerHTML = "按住 说话";
        });
      } else {
        this.$nextTick(() => {
          this.$refs["send-input"].innerHTML = "";
        });
      }
    },
    dsPopShow(n){
      if(n) {this.money = '';this.radio = '2'}
    },
    yqPopShow(n){
      if(n) {
        this.money = '';
        this.title = '';
        this.radio = '2'
      }
    },
    userPayPop(n){
      if(n) {this.radio = '2'}
    },
    
  },
  mounted() {
    this.shortcutsList();
    // if (this.isTeacher) {
    //   this.shortcutsList();
    // }
    var userAgent = navigator.userAgent; //获取userAgent信息
    var md = new MobileDetect(userAgent);
    var os = md.os(); //获取系统
    this.serverCont = os;
    let nowT = new Date().getTime();
    let timer = new Date($formatDates(new Date().getTime()) + ' 9:00:00').getTime()
    this.nightTimeB = new Date($formatDates(new Date().getTime()) + ' 21:00:00').getTime()/1000
    if(nowT < timer){ //当前时间小于了早上9点
      this.nightTimeB = new Date($formatDates(new Date().getTime() - 24*60*60*1000) + ' 21:00:00').getTime()/1000
    }
		this.nightTimeE = this.nightTimeB + (12 * 60 * 60)
  },
  created() {
    console.log(this.userid,'---');
    // window.addEventListener("scroll", function () {
    //   console.log(document.body.offsetHeight - window.innerHeight)
    // });
    // let text = "I \u2764\uFE0F emoji!";
    // console.log(this.$route.query);
    this.jsSdk();
    if (this.$route.query && this.$route.query.id) {
      const queryData = this.$route.query;
      this.roomID = queryData.id;
      this.tid = queryData.tid;
      this.remind = queryData.remind;
      this.oStatus = queryData.t;
      this.oid = queryData.oid;
      this.status = queryData.s;
      if (this.status == 1) {
        this.userMsgInpBox = false;
      }
      if(this.chatMsgList.length == 0){
        this.socket.send(
          JSON.stringify({
            action: "bindUid",
            api_token: localStorage.getItem("token"),
          })
        );
      }
      setTimeout(() => {
        this.sendSoMsg()
      }, 200);
    }
    
    let code = getQueryString("code");
    console.log(code, "----------------------code-------------------");
    if (!code) {
      if (this.$route.query && this.$route.query.s) {
        this.radio = this.$route.query.s;
      }
    } else {
      let state = getQueryString('state');
      // let state = "1orid1247#/orderConfirm";
      // console.log(state,'------------------------------888-');
      state = state.substring(0, state.indexOf("#/"));
      // console.log(state,'-------------------------------');
      let orderId = state.split("orid");
      this.roomID = orderId[0];
      this.orderId = orderId[1];
      if (code) {
        this.getopenid(code);
      }
    }
  },

  methods: {
    userPay(e){
      let item = JSON.parse(e)
      if(item.pay_status == 1) return
      this.userPayPop = true;
      this.userPayItem = item;
    },
    yqFn(){
      if(!this.money){
        this.Toast('请输入付款金额');
        return
      }
      this.yqPopShow = false;
      let msgId = Date.parse(new Date())
      let data = {
        "right": "1",
        "title": this.title,
        "avatar": this.userAvatar ? this.userAvatar : JSON.parse(uni.getStorageSync('user')).avatar,
        "type": 3,//0为文字，1为语音，2为图片  3付款
        "id": msgId,
        "loading": 1,
        'money':this.money,
        'sendMsg':0,
      };
      
      // 发送给服务器消息
      // onSendWS(JSON.stringify(data));
      let sendObj = {
        action: 'sendMsg',
        msg: this.title,
        id: msgId,
        roomId: this.roomID,
        type: 3,
        'money':this.money,
        api_token: this.token,
      }
      if(this.radio == 1){
        data.time = this.time;
        sendObj.time = this.time;
      }
      this.sendws(sendObj);
      this.chatMsgList.push(data);
    },
   //用户确认付款
    qrFn(){
      this.userPayPop = false
      this.loadingPop = true
      this.api.invitePay({
         dialogues:this.userPayItem.id,
        type:this.radio
      }).then(res => {
        this.orderPayFn(res.data.id,res.data.order_sn)
      },()=>{this.userPayPop = false})
    },
    dsFn(){
      if(!this.money){
        this.Toast('请输入打赏金额');
        return
      }
      if (
        ((this.allGold != 0 &&
          Number(this.money) > Number(this.allGold) / 10) ||
          this.allGold == 0) &&
        this.radio == 3
      ) {
        this.Toast("金币不足");
        return;
      }
      this.dsPopShow = false
      // this.$emit('dsFn',{m:this.money,t:this.radio})
      this.loadingPop = true;
      this.api.rewardTeacher({
        roomId:this.roomID,
        money:this.money,
        type:this.radio,
      }).then(res => {
        this.orderPayFn(res.data.id,res.data.order_sn)
      },() => {
        this.loadingPop = false;
      })
    },

    //订单支付
    orderPayFn(id,order_sn){
      console.log(this.roomID);
      if(this.radio == 1){ //微信支付
        this.api.getAppid().then((res) => {
          let appid = res.data;
          const url =
            location.origin +
            location.pathname +
            "?appid=" +
            appid +
            "#/chat";
          const redirect_uri = encodeURIComponent(url);
          let f = `${this.roomID}orid${id}`;
          this.loadingPop = false;
          // // return
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${f}#wechat_redirect`;
        });
        return
      }
      if(this.radio == 2){ //支付宝
        window.location.href = this.href + order_sn;
        return
      }
      this.api.pay({id:id}).then(res => {
        this.payParams = res;
        if (res.data.systemPay == 1) {//金币支付
          this.loadingPop = false;
          this.Toast("支付成功");
          return;
        }
        // this.wxPayFn();
      })
    },
     getopenid(code) {
      this.loadingPop = true;
      this.api.getOpenid({ opcode: code }).then((res) => {
        this.api.pay({ id: this.orderId, openid: res.data }).then((res) => {
          this.payParams = res;
          console.log(res);
          if (res.data.systemPay == 1) {
            this.Toast.success("支付成功");
            this.loadingPop = false;
            return;
          }
          this.wxPayFn(res);
        },() => {
            this.loadingPop = false;
        });
      },()=>{this.loadingPop = false});
    },
    wxPayFn(res) {
      let that = this;
      this.loadingPop = false;
      // 微信支付
      wx.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: res.data.paySign, // 支付签名
        success: function() {
          that.Toast.success("支付成功");
          that.loadingPop = false;
          // 支付成功后的回调函数
        },
        fail: () => {
          this.Toast("取消支付");
        },
      });
    },
    //消息通知
    noticeService(item){
      if(item.timerOut > 0) return;
      this.loadingPop = true
      this.api.noticeService({dialogues: item.dialoguesId}).then(res => {
        item.msgStatus = -1;
        this.loadingPop = false
        this.Toast('通知成功');
      },() => {
          item.msgStatus = -1;
          this.Toast('通知成功');
         this.loadingPop = false
      })
    },
    gopage(){
      this.$router.push('/msg')
    },
    sendSoMsg(){
      let num = 0;
      const I = setInterval(() => {
        // console.log(this.socket.readyState)
        this.token = localStorage.getItem("token")
        if (this.socket.readyState) {
          this.sendws({
            action: "msgList",
            api_token: this.token,
            roomId: this.roomID,
            page:this.page
          });
          this.socket.onmessage = this.getMessage;
          clearInterval(I);
        }else{
          num ++;
          if(num >= 10){
            clearInterval(I);
          }
					this.resocket()
        }
      }, 500);
    },
		resocket(){
			this.socket = new WebSocket(SOHERF);
			this.socket.onopen = this.onopen();
		},
		onopen(){
			if (localStorage.getItem("token")) {
			    this.socket.send(
			      JSON.stringify({
			        action: "bindUid",
			        api_token: localStorage.getItem("token"),
			      })
			    )
					setTimeout(() => {
						this.sendSoMsg()
					},200)
			}
		},
    endSever(type) {
      this.api.orderListByRoom({ id: this.roomID }).then((res) => {
        this.orderServe = res.data;
        if (res.data.length == 1) {
          this.chooseServe = res.data[0];
          if (type == 0) {
            this.dioTitle = "是否确定结束当前订单？";
          } else {
            this.dioTitle = "是否确定退款？";
          }
          this.dialogShow = true;
        } else {
          this.serveShow = true;
        }
      });
    },
    handleBiaoq() {
      this.showbq = !this.showbq;
      this.isVoice = false;
    },
    handleVoi() {
      this.isVoice = !this.isVoice;
      this.showbq = false;
    },
    tuikuan() {
      Dialog.confirm({
        message: "确定退款？",
      })
        .then(() => {})
        .catch(() => {
          // on cancel
        });
    },
    handleCancel() {
      this.dialogShow = false;
      this.chooseServe = {};
    },
    selectServeItem(item) {
      this.chooseServe = item;
    },
    //结束订单
    handleConfirm() {
      console.log(this.roomID);
      let s = "";
      if (this.dioTitle == "是否确定结束当前订单？") {
        s = "confirmOrder";
      } else {
        s = "teacherExamine";
      }
      this.sendws({
        action: s,
        api_token: this.token,
        id: this.chooseServe.id,
        roomId: this.roomID,
      });
      this.dialogShow = false;
    },
    shortcutsList() {
      this.api.shortcutsList({tid:this.tid}).then((res) => {
        this.quickList = res.data;
      });
    },
    playVoice() {
      var amr = new BenzAMRRecorder();
      amr
        .initWithUrl(
          "http://keyiche.anagelink.cn/upload/audio/20211024/wxupload_16350614416195.amr"
        )
        .then(function() {
          amr.play();
        });
      amr.onEnded(function() {
        alert("播放完毕");
      });
    },
    scrollToBottom() {
      // console.log("messageList change");
      this.$nextTick(() => {
        setTimeout(() => {
          let msg = document.getElementById("msgBox");
          // let msg = this.$el.querySelector('.wrapper');
          document.documentElement.scrollTop = msg.scrollHeight;
          document.body.scrollTop = msg.scrollHeight;
          // var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
          // scrollTop = msg.scrollHeight;
          // this.Toast(msg.scrollHeight);
        }, 500);
      });
    },
    sendws(msg) {
      this.socket.send(JSON.stringify(msg));
    },
    getMessage(msg) {
      const data = JSON.parse(msg.data);
      // code
      // 0：失败
      // 1：收到消息
      // 2：消息历史列表
      // 3：房间列表
      // 4：发送消息返回
      // 6：退款成功
      //  7：系统消息
      //  8：订单已结束
      //  999 绑定成功
      //  22 头像
      //23 聊天列表的聊天数字（老师端才用）
      if (data.code == 1 || data.code == 8 || data.code == 7) {
        if (data.data.roomId == this.roomID) {
          this.chatMsgList.push(data.data);
        }
        if (
          (data.code == 8 && data.data.roomStatus == 1) ||
          (data.code == 7 && data.data.roomStatus == 1)
        ) {
          this.userMsgInpBox = false;
        }
        if(data.code == 1 && !this.isTeacher && data.data.show_notice == 1 && data.data.notice == 0){ //下单通知
          this.chatMsgList.push(this.courseTimerFn(data.data));
        }
        if(!this.isTeacher && this.serTimerArr.length != 0 && data.data.right == 0 && data.data.status == 0){ //老师已回复
          this.chatMsgList.map(cm => {
            if(cm.msgStatus) cm.msgStatus = -1;
          })
          this.serTimerArr.map(s => {
            clearInterval(s)
          })
        }
        this.scrollToBottom();
      } else if (data.code == 0) {
        this.Toast(data.message);
      }else if (data.code == 2) {
        // this.chatMsgList = data.data.reverse();
        let list = data.data.list.reverse();
        if(this.page == 1){
          this.chatMsgList = []
        }
        list.push({page:this.page});//分页分界线 点击分页计算分页页面长度
        let copyList = JSON.parse(JSON.stringify(list));
        let pushLen = 0
        if(!this.isTeacher){
          list.map((rl,ri) => {
            if(rl.show_notice == 1 && rl.notice == 0){
              copyList.splice(ri+pushLen + 1,0,this.courseTimerFn(rl))
              pushLen ++;
            }
          })
        }
        this.total = data.data.total;
        this.chatMsgList = [...copyList,...this.chatMsgList];
        if(this.chatMsgList.length < this.total){
          this.moreShow = true;
        }else{
          this.moreShow = false
        }
        if(this.page == 1){
          this.scrollToBottom();
        }else{
          this.$nextTick(() => {
            let domid = 'page'+this.page
            let dom = document.getElementById(domid);
            document.documentElement.scrollTop = dom.offsetTop;
          })
        }
      }else if(data.code == 4){
        this.chatMsgList.map(c => {
          if(c.id == data.data.id){
            c.loading = 0
						c.dialogue = data.data.dialogue
          }
        })
        this.scrollToBottom();
      }else if(data.code == 999){
        this.page = 1
      } else if(data.code == 22){
        this.userAvatar = data.data;
      } else if(data.code == 23){
        this.numC = data.data.num;
        this.$forceUpdate()
      } else if(data.code == 30){
        this.chatMsgList.map(r => {
          if(r.id == data.data.dialogue || r.dialogue == data.data.dialogue){
            r.pay_status = 1;
            this.reloadTimer = new Date().getTime()
            this.$forceUpdate()
          }
        })
        console.log(this.chatMsgList);
      }
      // else{
      //   this.Toast(data.message)
      // }
    },
    //课程下单时间判断
    courseTimerFn(rl){
      let t = 0;
      if(rl.created_time >= this.nightTimeB && rl.created_time <= this.nightTimeE){//夜间订单
        t = this.nightTimeE - rl.created_time;
      }else{
        t = rl.created_time +10*60 - new Date().getTime()/1000  < 0 ? 0 : Math.trunc(rl.created_time +10*60 - new Date().getTime()/1000)
      }
      let obj = {
        timerOut:t,
        msgStatus:999,
        dialoguesId:rl.id
      }
      obj.tFn = setInterval(() => {
        if(t <= 1 || obj.timerOut <= 1){
          clearInterval(obj.tFn)
        }
        obj.timerOut = obj.timerOut - 1;
        this.$forceUpdate()
      },1000)
      this.serTimerArr.push(obj.tFn);
      return obj
    },
    onfocus() {
      this.inputFocus = true;
      // console.log("this.inputFocus", this.inputFocus);
      this.showMenu = false;
      this.showbq = false;
      if (this.serverCont == "iOS") {
        // console.log($('.footer'));
        setTimeout(() => {
          $(".footer")[0].scrollIntoView(true);
          this.scrollToBottom();
          let ele = $('html');
          if (ele.scrollHeight > ele.clientHeight) {
            setTimeout(function() {
              //设置滚动条到最底部
              ele.scrollTop = ele.scrollHeight;
              ele.style.opacity = 1;
            }, 500);
          }
        }, 100);
      }
    },
    onblur() {
      // console.log('blur');
      this.sel = window.getSelection();
      this.range = this.sel.getRangeAt(0);
      this.range.deleteContents();
      setTimeout(() => {
        this.inputFocus = false;
      }, 50);
    },
    oninput(e) {
      // this.inputValue += e.data;
      // console.log(e.target.innerHTML);
      this.inputValue = e.target.innerHTML;
    },
    handleClick() {
      console.log("handle");
    },
    oninputclick() {
      // this.keepLastIndex(e.target);
    },
    //发送快捷消息
    sendQuick(text) {
      let msgId = Date.parse(new Date())
      this.sendws({
        action: "sendMsg",
        api_token: this.token,
        msg: text,
        id:msgId,
        roomId: this.roomID,
      });
      this.userSendMsgContent = {
        title: text,
        right: 1,
        type: 0,
        id:msgId,
        avatar: this.userAvatar ? this.userAvatar :JSON.parse(localStorage.getItem("user")).avatar,
        loading:1
      }
      // console.log(this.sendAllMsgArr);
      // this.sendAllMsgArr.push(this.userSendMsgContent)
      this.chatMsgList.push(this.userSendMsgContent);
      this.userSendMsgContent = {};
      this.inputFocusShow = false;
      this.scrollToBottom();
    },
    //发送消息
    sendmsg() {
      let msgText = this.$refs["send-input"].innerHTML;
      // const msgText = this.inputValue;
      msgText =this.replaceStr(msgText)
      let msgId = Date.parse(new Date())
      // console.log(msgText, "---------");
      this.sendws({
        action: "sendMsg",
        api_token: this.token,
        msg: msgText,
        id:msgId,
        roomId: this.roomID,
      });
      this.userSendMsgContent = {
        title: msgText,
        right: 1,
        type: 0,
        id:msgId,
        avatar: this.userAvatar ? this.userAvatar :JSON.parse(localStorage.getItem("user")).avatar,
        loading:1
      }
      this.$refs["send-input"].innerHTML = "";
      this.inputValue = "";
      this.keepLastIndex(this.$refs["send-input"]);
      // this.sendAllMsgArr.push(this.userSendMsgContent)
      this.chatMsgList.push(this.userSendMsgContent);
      this.userSendMsgContent = {};
      this.scrollToBottom();
    },
     more(){
      this.page ++;
      this.sendws({
        action: "msgList",
        api_token: this.token,
        roomId: this.roomID,
        page:this.page
      });
    },
    replaceStr(str){
      let s = JSON.stringify(str).replace(/&lt;/g,"<");
      s = s.replace(/&gt;/g,">");
      s = s.replace(/<(?!img).*?>/g, "")
      s = s.replace(/\\/g, "")
      
      s = s.substring(1,s.length-1)
      console.log(s);
      return s
    },
    keepLastIndex(obj) {
      if (window.getSelection) {
        //ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题
        let range = window.getSelection(); //创建range
        range.selectAllChildren(obj); //range 选择obj下所有子内容
        // range.collapseToEnd(); //光标移至最后
      } else if (document.selection) {
        //ie10 9 8 7 6 5
        let range = document.selection.createRange(); //创建选择对象
        //var range = document.body.createTextRange();
        range.moveToElementText(obj); //range定位到obj
        // range.collapse(false); //光标移至最后
        range.select();
      }
    },
    insertHtmlAtCaret(html) {
      if (window.getSelection) {
        // IE9 and non-IE
        if (this.sel.getRangeAt && this.sel.rangeCount) {
          let el = document.createElement("div");
          el.innerHTML = html;
          let frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          this.range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            this.range = this.range.cloneRange();
            this.range.setStartAfter(lastNode);
            this.range.collapse(true);
            this.sel.removeAllRanges();
            this.sel.addRange(this.range);
          }
        }
      } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
      // this.inputValue = this.$refs["send-input"].innerHTM; //这个也很重要。因为如果不写可能就会覆盖了原来内容替换成你添加的。或者是干脆不显示了。textContent是全局变量是你输入的内容。
    },

    //发送表情
    sendBiaoQing(item) {
      // const unicode = this.decToHex(item);
      // const img = twemoji.parse(item);
      const imgUrl = this.extractImgUrl(item);
      const img = `<img style="width:20px;margin:0 2px;" src="${imgUrl}" />`;
      if (this.sel && this.range) {
        // this.insertHtmlAtCaret(img);
        this.insertHtmlAtCaret(item);
      } else {
        // this.$refs["send-input"].innerHTML = this.inputValue + img;
        this.$refs["send-input"].innerHTML = this.inputValue + item;
      }
      this.inputValue = this.$refs["send-input"].innerHTML;
      // console.log(this.inputValue);
      // this.inputValue = "";
    },
    ontouchstart() {
      this.Toast.loading({
        message: "录音中",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.startTime = new Date().getTime();
      wx.startRecord();
    },
    ontouchend() {
      const that = this;
      this.endTime = new Date().getTime();
      const time = Math.ceil((this.endTime - this.startTime) / 1000);
      this.Toast.clear();
      wx.stopRecord({
        success: function(res) {
          var localId = res.localId;
          let msgId = Date.parse(new Date());
          wx.uploadVoice({
            localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function(res) {
              var serverId = res.serverId; // 返回音频的服务器端ID
              that.api.downAndSaveFile({ media_id: serverId }).then((res) => {
                that.sendws({
                  action: "sendMsg",
                  api_token: that.token,
                  msg: res.data.url,
                  roomId: that.roomID,
                  type: "1",
                  id:msgId,
                  timeLen: time,
                });
                // that.chatMsgList.push({
                //   title: res.data.url,
                //   right: 1,
                //   type: "1",
                //   timeLen: time,
                //   time:time,
                //   avatar:that.isTeacher ? JSON.parse(localStorage.getItem("user")).get_teacher.avatar: JSON.parse(localStorage.getItem("user")).avatar,
                // });
                that.userSendMsgContent = {
                  title: res.data.url,
                  right: 1,
                  type: "1",
                  id:msgId,
                  timeLen: time,
                  time:time,
                  avatar:this.userAvatar ? this.userAvatar :JSON.parse(localStorage.getItem("user")).avatar,
                  loading:1
                }
                that.sendAllMsgArr.push(that.userSendMsgContent)
                that.userSendMsgContent = {};
                that.$forceUpdate();
                that.scrollToBottom();
              });
            },
          });
        },
      });
    },
    //提取图片地址
    extractImgUrl(data) {
      let reg = /<[\s\S]*?src="([^\s]+)".*/;
      const img = twemoji.parse(data);
      const url = img.match(reg);
      return url[1];
      // return data;
    },
    async sendImg(file) {
      const imgurl = await uploadimg(file);
      let msgId = Date.parse(new Date())
      if (imgurl) {
        this.sendws({
          action: "sendMsg",
          api_token: this.token,
          msg: imgurl.url,
          id:msgId,
          roomId: this.roomID,
          type: "2",
        });
        // this.chatMsgList.push({
        //   title: imgurl.complete_url,
        //   right: 1,
        //   type: 2,
        //   avatar:  this.isTeacher ? JSON.parse(localStorage.getItem("user")).get_teacher.avatar : JSON.parse(localStorage.getItem("user")).avatar,
        // });
        this.userSendMsgContent = {
          title: imgurl.complete_url,
          right: 1,
          type: 2,
          id:msgId,
          avatar:  this.userAvatar ? this.userAvatar :JSON.parse(localStorage.getItem("user")).avatar,
          loading:1
        }
        // this.sendAllMsgArr.push(this.userSendMsgContent)
        this.chatMsgList.push(this.userSendMsgContent);
        this.userSendMsgContent = {};
        this.scrollToBottom();
      } else {
        console.log("上传失败");
      }
    },
    jsSdk() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
      } else {
        url = window.location.href;
      }
      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: [
            "chooseImage",
            "getLocalImgData",
            "startRecord",
            "stopRecord",
            "uploadVoice",
            "playVoice",
          ], // 必填，需要使用的JS接口列表
        });
        wx.ready(function() {
          console.log("===========jssdk===========");
          wx.error((res) => {
            console.log("sdk-err", res);
          });
          // TODO
        });
        wx.error(function() {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      });
    },
  },
  // 在创建之前，添加body的style属性， 单独设置背景色
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F0F0F0");
  },
  // 在销毁前，将body的style属性删除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>
<style lang="scss" scoped>
.content{
  user-select: none;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none;
}
#msgBox {
  min-height: 100vh;
  overflow-y: scroll;
  // background: #4fd9d5;
}
.chat {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0.24rem;
}
.syetem-notice {
  font-size: 0.24rem;
  color: #ffffff;
  background: #cccccc;
  border-radius: 0.22rem;
  padding: 0 0.34rem;
  display: inline-block;
  max-width: 6rem;
  margin: 0.34rem auto;
}

.ps-time {
  font-size: 0.24rem;
  font-weight: 500;
  color: #cccccc;
  text-align: center;
  margin-bottom: 0.28rem;
}

.footer {
  width: 100%;
  background: #f6f6f6;
  position: fixed;
  bottom: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .send-msg {
    height: 50px;
    border-top: 1px solid #e6e6e6;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
    }
    .expression {
      margin-right: 12px;
    }
    .send-input {
      //   border: 1px solid;
      margin: 0 10px;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      background: #ffffff;
      height: 33px;
      border-radius: 5px;
      overflow: hidden;
      flex: 1;
      padding: 0 5px;
      .voice-box {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      #send-input {
        // overflow: hidden;
        overflow-y: scroll;
        -webkit-user-select: text;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        outline: none;
        // line-height: 33px;
        white-space: nowrap;
        font-size: 15px;
        padding-top: 5px;
      }
    }
    .send-btn {
      height: 33px;
      border-radius: 5px;
      color: #ffffff;
      background: #4fd9d5;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
    }
  }

  .foot-menu {
    height: 120px;
    display: flex;
    overflow-y: scroll;
    flex-wrap: wrap;
    .foot-menu-scroller {
      display: flex;
      width: 100%;
      overflow-x: scroll;
      .foot-menu-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      > div {
        width: calc(100% / 5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        p {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          margin-top: 3px;
        }

        img {
          width: 60px;
        }
      }
    }
  }
  .foot-menu-bq {
    height: 120px;
    overflow-y: scroll;
    .bq {
      display: flex;
      flex-wrap: wrap;
      margin: 0 12px;
      // justify-content: space-around;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        img {
          width: 2em !important;
        }
      }
    }
  }
  .foot-menu-kjdu {
    height: 120px;
    overflow-y: scroll;
    .quick {
      div {
        text-align: center;
        // height: 0.98rem;
        font-size: 0.3rem;
        padding: .2rem 0;
        color: #333333;
        text-align: center;
        // line-height: 0.98rem;
        border-bottom: 1px solid #f0f0f0;
        margin: 0 0.24rem;
        box-sizing: border-box;
        &:last-child {
          border-bottom: none;
        }
      }
      .add-quick {
        color: #4fd9d5;
      }
    }
  }
}
.quick {
  div {
    // height: 0.98rem;
    padding: .2rem 0;
    font-size: 0.3rem;
    color: #333333;
    text-align: center;
    // line-height: 0.98rem;
    border-bottom: 1px solid #f0f0f0;
    margin: 0 0.24rem;
    box-sizing: border-box;
    &:last-child {
      border-bottom: none;
    }
  }
  .add-quick {
    color: #4fd9d5;
  }
}
.dialog-list {
  max-height: 3rem;
  overflow-y: scroll;
  .dialog-list-item {
    // border-bottom: 1px solid #eee;
    min-height: 0.8rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    border-top: 1px solid #eee;
    &.choose {
      border: 1px solid #4fd9d5;
      color: #4fd9d5;
    }
  }
}
.c-dialog-list {
  padding-bottom: 0.14rem;
}
.image {
  width: 100%;
}
.name-box {
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  font-size: 0.3rem;
}
.dio-btn-flex {
  display: flex;
  justify-content: space-between;
  padding: 0 0.12rem;
}
.dio-cancel,
.dio-sure {
  width: 47%;
  border: 1px solid #4fd9d5;
  border-radius: 0.16rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #4fd9d5;
}
.dio-sure {
  background: #4fd9d5;
  color: #fff;
}
.more{
  text-align: center;
  padding-top: 20px;
}
.numC{
  width: .5rem;
  text-align: center;
  height: .5rem;
  box-sizing: border-box;
  // padding: .1rem;
  line-height: .5rem;
  font-size: .2rem;
  border-radius: 50%;
  background: #999;
  color: #fff;
  position: fixed;
  z-index: 666;
  left: .1rem;
  top: .2rem;
}
.notic-btn{
  width: 3rem;
  height: .6rem;
  border-radius: .1rem;
  line-height: .6rem;
  text-align: center;
  background: #4fd9d5;
  color: #fff;
  margin-bottom: 0.3rem;
}
.popmask{
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
}
  .pop-pop{
		// width: 6.06rem;
		padding-bottom: .30rem;
	}
	.ser-btn{
		height: .8rem;
		line-height: .8rem;
		margin:0 auto;
		margin-top: .6rem;
		text-align: center;
		border-radius: .1rem;
	}
	.p-l{
		border: 1px solid #eee;
		height: .8rem;
		border-radius: .1rem;
		margin-top: .3rem;
    display: flex;
    align-items: center;
    margin-bottom: .3rem;
	}
  .flex{
    display: flex;
  }
  .flex_between{
    justify-content: space-between;
  }
  .main_bg{
    background: #4fd9d5;
  }
  .txt_center {
    text-align: center;
  }
  .f36{
    font-size: .36rem;
  }
  .pt20{
    padding-top: .2rem;
  }
  .plr30{
    padding-left: .3rem;
    padding-right: .3rem;
  }
  .pop-int{
    font-size: .26rem;
    border: 0;
  }
  .flex_items{
    align-items: center;
  }
  .pop-btn{
    height: .8rem;
    line-height:.8rem;
    margin: 0 auto;
    margin-top: .3rem;
    text-align: center;
    border-radius: .1rem;
    background: #4fd9d5;
    color: #fff;
  }
  .flex_end{
    justify-content: flex-end;
  }
  .pr20{
    padding-right: .2rem;
  }
</style>
